<template>
    <a-spin :spinning="isLoading" size="large">
        <div class="spin-content">
            <a-card 
                :bordered="false" 
                class="euclid-table-card header-solid h-full c_meetinf_link_card_body" 
                :bodyStyle="{padding: 0,}" 
            >
                <template #title>
                    <a-row type="flex" align="middle">
                        <a-col :span="14" :xl="4" :md="6" :sm="8" >
                            <h5 class="font-semibold m-0">{{$t('page-titles.meetings-link')}}</h5>
                        </a-col>
                        <a-col :span="10" :xl="4" :md="4" :sm="8" >
                            <a-button type="primary" @click.prevent="navigateTo('CreateMeetingLink')">
                                {{$t('meetings-link-page.add-btn-caption')}}
                            </a-button>
                        </a-col>
                        <a-col :span="18" :md="15" style="display: flex; align-items: center; justify-content: flex-end">
                            <!-- <a-radio-group v-model="authorsHeaderBtns" size="small">
                                <a-radio-button value="active">ACTIVE</a-radio-button>
                                <a-radio-button value="inactive">INACTIVE</a-radio-button>
                                <a-radio-button value="all">ALL</a-radio-button>
                            </a-radio-group> -->
                        </a-col>
                    </a-row>
                </template>
                <a-table :columns="columns" :data-source="data" :pagination="false" rowKey="id">
                    <template slot="name" slot-scope="name">
                        <div class="table-avatar-info">
                            <div class="avatar-info">
                                <h6 style="font-weight: 600">{{ name }}</h6>
                            </div>
                        </div>
                    </template>
                    <template slot="link" slot-scope="link">
                        <h6 style="font-weight: 600">{{ link }}</h6>
                    </template>
                    <!-- "status ? 'ant-tag-primary' : 'ant-tag-muted'" -->

                    <template slot="official" slot-scope="group1">
                        <div class="table-avatar-info">
                            <a-avatar shape="square" :src="group1.imageUrl" />
					        <div class="avatar-info">
						        <h6 v-show="locale == 'bn'">{{ group1.nameBn }}</h6>
						        <h6 v-show="locale == 'en'">{{ group1.name }}</h6>
						        <p v-show="locale == 'bn'">{{ group1.designationBn }}</p>
						        <p v-show="locale == 'en'">{{ group1.designation }}</p>
					        </div>      
                        </div>
                    </template>

                    <template slot="editBtn" slot-scope="row">
                        <a-tooltip>
                            <a-button type="primary" shape="circle" @click="navigateTo('EditMeetingLink',{},{id:row.id})" icon="edit" :data-id="row.id">
                            </a-button>
                            <template slot="title">
                               {{$t('tool-tip.edit')}}
                            </template>
                        </a-tooltip>
                    </template>
                    <!-- <template slot="deleteBtn" slot-scope="row">
                        <a-tooltip>
                            <template slot="title">
                                delete
                            </template>
                            <a-button type="danger" shape="circle" icon="delete" :data-id="row.key">
                            </a-button>
                            
                        </a-tooltip>
                    </template> -->

                </a-table>
            </a-card>
        </div>
    </a-spin>
</template>

<script>


import { mapState } from 'pinia';
import {host, meetingsClient } from '../../api/config';	
import { navigationMixin } from "../../mixins/navigation-mixin.js";
import { useLocaleStore } from "../../stores/locale-store";

export default ({
    mixins: [ navigationMixin ],
    data() {
        return {
            data: [],
            isLoading: true,
            authorsHeaderBtns: 'active',
            columns: [
                {
                    title: this.$t('table-headers.name'),
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' },
                    width: 200,
                },
                {
                    title: this.$t('table-headers.link'),
                    dataIndex: 'link',
                    scopedSlots: { customRender: 'link' },
                    width: 250,
                },
                {
                    title: this.$t('table-headers.official'),
                    dataIndex: 'group1',
                    scopedSlots: { customRender: 'official' },
                    width: 300,
                },
                {
                    title: this.$t('table-headers.actions'),
                    scopedSlots: { customRender: 'editBtn' },
                    width: 100,
                },
                {
                    title: '',
                    scopedSlots: { customRender: 'deleteBtn' },
                    width: 100,
                },
            ]
        }
    },
    computed: {
        ...mapState(useLocaleStore, [ 'locale' ])
    },
    mounted() {
        this.isLoading = true;
        meetingsClient.fetchAllOfPage({  page: 1, size: 20 }).then(res => {
            if (!res.networkError && res.status == 200 && res.body.list) {
                res.body.list.forEach(o => {
                    if (o.official.imageUrl && o.official.imageUrl.length > 0) {
                        o.official.imageUrl = host + o.official.imageUrl;
                    } else {
                        o.official.imageUrl = '/images/default-avatar.jpg';
                    }
                    o.group1 = {
                        'imageUrl': o.official.imageUrl,
                        'name': o.official.name,
                        'nameBn': o.official.nameBn,
                        'designation': o.official.designation.name,
                        'designationBn': o.official.designation.nameBn
                    }
                })

                // console.log(res.body.list);
                this.data = res.body.list;
            }
            this.isLoading = false;
        });


    },
    watch: {
        locale() {
            this.columns[0].title = this.$t('table-headers.name');
            this.columns[1].title = this.$t('table-headers.link');
            this.columns[2].title = this.$t('table-headers.official');
            this.columns[3].title = this.$t('table-headers.actions');
        }
    }
})

</script>